import { MachineException } from "@/model/data/logAnalysis/MachineException";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetMachineExceptionImageResData } from "./GetMachineExceptionImageResData";

const ENDPOINT = "/log_analysis/exception/image";

export class GetMachineExceptionImageCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetMachineExceptionImageReqData = null;

    constructor(params: GetMachineExceptionImageReqData) {
        super();
        this.payload = { ...params };
    }

    public async execute(): Promise<GetMachineExceptionImageResData> {
        let res = await this.executeCommand(this.payload);
        return new GetMachineExceptionImageResData(res);
    }
}

export class GetMachineExceptionImageReqData {
    installationName: string = null;
    serialNumber: string = null;
    machineException: MachineException = null;
    height: number = null;

    constructor(installationName: string, serialNumber: string, machineException: MachineException, height: number) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
        this.machineException = machineException;
        this.height = height;
    }
}
